import { ApiRequestInterceptor } from "./apiRequest";
import { HEADER } from "../constants/endpoints/endpoints";

export const fetchHeader = async () => {
    const method = "GET";
    const response = await ApiRequestInterceptor(HEADER.header, method);
    const { code, data } = response;

    if (code === 200) {
        return { code, data };
    } else {
        throw new Error("Error al obtener datos de header");
    }
};
